import { Card, CardHeader, CardTitle, CardContent } from "../ui/card";
import { Bar } from 'react-chartjs-2';

const BarChartCard = ({ title, data }) => (
  <Card className="bg-white border border-indigo-100 rounded-2xl shadow-lg overflow-hidden">
    <CardHeader className="bg-gradient-to-r from-indigo-50 to-white">
      <CardTitle className="text-indigo-700">{title}</CardTitle>
    </CardHeader>
    <CardContent className="h-[300px] p-4">
      <Bar 
        data={data} 
        options={{ 
          responsive: true, 
          maintainAspectRatio: false,
          plugins: {
            legend: {
              labels: {
                font: {
                  family: "'Inter', sans-serif",
                  size: 12
                }
              }
            }
          },
          scales: {
            x: {
              grid: {
                display: false
              }
            },
            y: {
              grid: {
                color: 'rgba(0, 0, 0, 0.05)'
              }
            }
          }
        }} 
      />
    </CardContent>
  </Card>
);

export default BarChartCard;